import { render, staticRenderFns } from "./TicketContactDetail.vue?vue&type=template&id=4456f723&"
import script from "./TicketContactDetail.vue?vue&type=script&lang=js&"
export * from "./TicketContactDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports